export default __webpack_public_path__ + "static/media/Acrylic-Paints.9dc3d0ff.jpg";